/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function InfoCircleFilledIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M20.031 36c-5.75 0-11-3-13.875-8-2.875-4.937-2.875-11 0-16 2.875-4.937 8.125-8 13.875-8 5.688 0 10.938 3.063 13.813 8 2.875 5 2.875 11.063 0 16-2.875 5-8.125 8-13.813 8m-2.5-11c-.875 0-1.5.688-1.5 1.5 0 .875.625 1.5 1.5 1.5h5c.813 0 1.5-.625 1.5-1.5 0-.812-.687-1.5-1.5-1.5h-.5v-5.5c0-.812-.687-1.5-1.5-1.5h-3c-.875 0-1.5.688-1.5 1.5 0 .875.625 1.5 1.5 1.5h1.5v4zm2.5-13c-1.125 0-2 .938-2 2 0 1.125.875 2 2 2 1.063 0 2-.875 2-2 0-1.062-.937-2-2-2"/>}
        </IconWrapper>);
}
